export default "__VITE_ASSET__goDleBEB__"